import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _DEFAULT_VOLUME_LEVEL, _USER_TYPE_TO_BACKGRO, _DEFAULT_SUBSCRIBER_T;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export * from "./events";
export * from "./call-window";
export * from "./provider";
export var CALL_TYPE = {
  AV_CALL: 'AV_CALL',
  SCREEN_CALL: 'SCREEN_CALL',
  BROADCAST: 'BROADCAST',
  GROUP_CALL: 'GROUP_CALL'
};
export var AV_CALL_TYPE = {
  AUDIO_CALL: 'AUDIO_CALL',
  VIDEO_CALL: 'VIDEO_CALL'
};
export var PRODUCT_TYPE = {
  AV_CALL: 'AV_CALL',
  BROADCAST: 'BROADCAST',
  GROUP_CALL: 'GROUP_CALL',
  SCREEN_GRAB: 'SCREEN_GRAB',
  SCREEN_SHARE: 'SCREEN_SHARE'
};
export var AV_OPTIONS = {
  CUE_CALL: 'Cue Call',
  DEFAULT: 'Default'
};
export var SERVICE_PROVIDER = {
  HMS: 'HMS',
  JANUS: 'JANUS',
  OPENTOK: 'OPENTOK',
  WEBRTC: 'WEBRTC'
};
export var ERROR_CODE_PROVIDER = _objectSpread(_objectSpread({}, SERVICE_PROVIDER), {}, {
  DEFAULT: 'DEFAULT'
});
export var USER_TYPES = {
  STUDENT: 'student',
  TEACHER: 'teacher',
  AC: 'academic_counselor'
};
var OPENTOK_DEFAULT_VOLUME_LEVEL = 100;
var HMS_DEFAULT_VOLUME_LEVEL = 100;
export var DEFAULT_VOLUME_LEVEL_MAP = (_DEFAULT_VOLUME_LEVEL = {}, _defineProperty(_DEFAULT_VOLUME_LEVEL, SERVICE_PROVIDER.HMS, HMS_DEFAULT_VOLUME_LEVEL), _defineProperty(_DEFAULT_VOLUME_LEVEL, SERVICE_PROVIDER.OPENTOK, OPENTOK_DEFAULT_VOLUME_LEVEL), _DEFAULT_VOLUME_LEVEL);
export var OT_PACKAGE_SENTRY_ISSUE_LIST = ['OT_HARDWARE_UNAVAILABLE', 'OT_UNABLE_TO_CAPTURE_SCREEN', 'OT_USER_MEDIA_ACCESS_DENIED', 'OT_UNEXPECTED_SERVER_RESPONSE', "null is not an object (evaluating 'Te.subscribeToVideo')", "Cannot read property 'socketId' of null", 'NotAllowedError: The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.']; // These sentry issues are coming from opentok package, we already inform them to fix this.

export var TRACK_TYPES = {
  AUDIO: 'audio',
  VIDEO: 'video'
};
export var SOURCE = {
  SCREEN: 'screen',
  CAMERA: 'camera',
  MIC: 'mic'
};
export var BROADCAST_TIMEOUT_MESSAGE = {
  TIMEOUT: 'Timeout',
  INIT_TIMEOUT: 'Broadcast call ended. No student joined the call.',
  RECONNECT_TIMEOUT: 'Broadcast call ended. There are no students in the call.'
};
export var VIRTUAL_BACKGROUND_IMAGE = {
  AC_SRC: 'https://cuemath-intel.s3.ap-southeast-1.amazonaws.com/virtual-background/AC-background-v2.png',
  TEACHER_SRC: 'https://cuemath-intel.s3.ap-southeast-1.amazonaws.com/virtual-background/Teacher-background-v2.png'
};
export var USER_TYPE_TO_BACKGROUND_IMAGE = (_USER_TYPE_TO_BACKGRO = {}, _defineProperty(_USER_TYPE_TO_BACKGRO, USER_TYPES.AC, VIRTUAL_BACKGROUND_IMAGE.AC_SRC), _defineProperty(_USER_TYPE_TO_BACKGRO, USER_TYPES.TEACHER, VIRTUAL_BACKGROUND_IMAGE.TEACHER_SRC), _USER_TYPE_TO_BACKGRO);
var SDK_CUEMATH_ERROR_CODES = {
  CM_SDK_1: 'CM_SDK_1',
  CM_SDK_2: 'CM_SDK_2',
  CM_SDK_3: 'CM_SDK_3',
  CM_SDK_4: 'CM_SDK_4',
  CM_SDK_5: 'CM_SDK_5',
  CM_SDK_6: 'CM_SDK_6',
  CM_SDK_7: 'CM_SDK_7',
  CM_SDK_8: 'CM_SDK_8',
  CM_SDK_9: 'CM_SDK_9',
  CM_SDK_10: 'CM_SDK_10',
  CM_SDK_11: 'CM_SDK_11',
  CM_SDK_12: 'CM_SDK_12',
  CM_SDK_13: 'CM_SDK_13',
  CM_SDK_14: 'CM_SDK_14',
  CM_SDK_15: 'CM_SDK_15',
  CM_SDK_16: 'CM_SDK_16',
  CM_SDK_17: 'CM_SDK_17',
  CM_SDK_18: 'CM_SDK_18',
  CM_SDK_19: 'CM_SDK_19',
  CM_SDK_20: 'CM_SDK_20',
  CM_SDK_21: 'CM_SDK_21',
  CM_SDK_22: 'CM_SDK_22',
  CM_SDK_23: 'CM_SDK_23',
  CM_SDK_24: 'CM_SDK_24',
  CM_SDK_25: 'CM_SDK_25',
  CM_SDK_26: 'CM_SDK_26',
  CM_SDK_27: 'CM_SDK_27'
}; // Reference: https://www.notion.so/cuemath/Analytics-Upgrade-8fd2ddd953de47ccab959e96262235f4#186c459c257d4f6b93494189dc2514cd

export var CUEMATH_ERROR_CODES = _objectSpread({
  CM_MEDIA_CAMERA_1: 'CM_MEDIA_CAMERA_1',
  CM_MEDIA_CAMERA_2: 'CM_MEDIA_CAMERA_2',
  CM_MEDIA_CAMERA_3: 'CM_MEDIA_CAMERA_3',
  CM_MEDIA_CAMERA_4: 'CM_MEDIA_CAMERA_4',
  CM_MEDIA_CAMERA_5: 'CM_MEDIA_CAMERA_5',
  CM_MEDIA_CAMERA_6: 'CM_MEDIA_CAMERA_6',
  CM_MEDIA_CAMERA_7: 'CM_MEDIA_CAMERA_7',
  CM_MEDIA_CAMERA_8: 'CM_MEDIA_CAMERA_8',
  CM_MEDIA_CAMERA_9: 'CM_MEDIA_CAMERA_9',
  CM_MEDIA_CAMERA_10: 'CM_MEDIA_CAMERA_10',
  CM_MEDIA_CAMERA_11: 'CM_MEDIA_CAMERA_11',
  CM_MEDIA_CAMERA_12: 'CM_MEDIA_CAMERA_12',
  CM_MEDIA_CAMERA_13: 'CM_MEDIA_CAMERA_13',
  CM_MEDIA_CAMERA_14: 'CM_MEDIA_CAMERA_14',
  CM_MEDIA_CAMERA_15: 'CM_MEDIA_CAMERA_15',
  CM_MEDIA_MIC_1: 'CM_MEDIA_MIC_1',
  CM_MEDIA_MIC_2: 'CM_MEDIA_MIC_2',
  CM_MEDIA_MIC_3: 'CM_MEDIA_MIC_3',
  CM_MEDIA_MIC_4: 'CM_MEDIA_MIC_4',
  CM_MEDIA_MIC_5: 'CM_MEDIA_MIC_5',
  CM_MEDIA_MIC_6: 'CM_MEDIA_MIC_6',
  CM_MEDIA_MIC_7: 'CM_MEDIA_MIC_7',
  CM_MEDIA_MIC_8: 'CM_MEDIA_MIC_8',
  CM_MEDIA_MIC_9: 'CM_MEDIA_MIC_9',
  CM_MEDIA_MIC_10: 'CM_MEDIA_MIC_10',
  CM_MEDIA_MIC_11: 'CM_MEDIA_MIC_11',
  CM_MEDIA_MIC_12: 'CM_MEDIA_MIC_12',
  CM_MEDIA_MIC_13: 'CM_MEDIA_MIC_13',
  CM_MEDIA_MIC_14: 'CM_MEDIA_MIC_14',
  CM_MEDIA_MIC_15: 'CM_MEDIA_MIC_15',
  CM_MEDIA_1: 'CM_MEDIA_1',
  CM_MEDIA_2: 'CM_MEDIA_2',
  CM_MEDIA_3: 'CM_MEDIA_3',
  CM_MEDIA_4: 'CM_MEDIA_4',
  CM_MEDIA_5: 'CM_MEDIA_5',
  CM_MEDIA_6: 'CM_MEDIA_6',
  CM_MEDIA_7: 'CM_MEDIA_7',
  CM_MEDIA_8: 'CM_MEDIA_8',
  CM_MEDIA_9: 'CM_MEDIA_9',
  CM_MEDIA_10: 'CM_MEDIA_10',
  CM_MEDIA_11: 'CM_MEDIA_11',
  CM_MEDIA_12: 'CM_MEDIA_12',
  CM_MEDIA_13: 'CM_MEDIA_13',
  CM_MEDIA_14: 'CM_MEDIA_14',
  CM_MEDIA_15: 'CM_MEDIA_15',
  CM_MEDIA_SCREEN_1: 'CM_MEDIA_SCREEN_1'
}, SDK_CUEMATH_ERROR_CODES);
export var DEFAULT_SUBSCRIBER_TEMPLATE = (_DEFAULT_SUBSCRIBER_T = {}, _defineProperty(_DEFAULT_SUBSCRIBER_T, USER_TYPES.TEACHER, [SOURCE.CAMERA, SOURCE.SCREEN]), _defineProperty(_DEFAULT_SUBSCRIBER_T, USER_TYPES.STUDENT, [SOURCE.CAMERA, SOURCE.SCREEN]), _defineProperty(_DEFAULT_SUBSCRIBER_T, USER_TYPES.AC, [SOURCE.CAMERA]), _DEFAULT_SUBSCRIBER_T);
export var PAUSE_STATE_TEXT = "I'll be right back";
//# sourceMappingURL=index.js.map